import React from 'react';
import {Modal, ModalBody, ModalHeader} from 'reactstrap';

const ratings = {
    0 : 'No evaluado',
    1 : 'Muy mal',
    2 : 'Mal',
    3 : 'Regular',
    4 : 'Bien',
    5 : 'Muy bien',
};

const satistaction = {
    0 : 'No evaluado',
    1 : "Totalmente insatisfecho",
    2 : "Insatisfecho",
    3 : "Ni satisfecho ni insatisfecho",
    4 : "Satisfecho",
    5 : "Muy satisfecho",
};

const willing = {
    0 : 'No evaluado',
    1 : "Totalmente indispuesto",
    2 : "Indispuesto",
    3 : "Ni dispuesto ni indispuesto",
    4 : "Dispuesto",
    5 : "Muy dispuesto",
};

export default function DetailModal(props) {
    const {report} = props;
    return (
        <Modal isOpen={props.isOpen} toggle={props.toggle} size="lg">
            <ModalHeader toggle={props.toggle}>
                Detalle de encuesta
            </ModalHeader>
            <ModalBody>
                <div className="card my-1">
                    <h5 className="card-block card-title my-0">
                        ¿Cómo calificaría los siguientes aspectos del Asesor PyME Banorte?  
                    </h5>
                    <table className="table table-striped mb-0">
                        <tbody>
                            {
                                 ! report  || report.survey_answers.length === 0 ? null :
                                report.survey_answers.filter((answer) => answer.survey_question.kind === 'rating').map(answer => (
                                    <DetailQuestionRating answer={answer} key={answer.id}/>
                                ))
                            }
                        </tbody>
                    </table>
                </div>

                {
                     ! report  || report.survey_answers.length === 0 ? null :
                    report.survey_answers.filter((answer) => answer.survey_question.kind !== 'rating').map(answer => (
                        <DetailQuestion key={answer.id} answer={answer} />
                    ))
                }
            </ModalBody>
        </Modal>
    );
}

function DetailQuestionRating(props) {
    const { answer } = props;
    const value = parseInt(answer.answer, 10);
    return (
        <tr>
            <td style={{width: '50%'}}>
                {answer.survey_question.text}
            </td>
            <td style={{width: '50%'}}>
                {ratings[value]}
            </td>
        </tr>
    );
}

function DetailQuestionText(props) {
    const { answer } = props;
    return (
        <div className="card my-1">
            <div className="card-block">
                <div className="row">
                    <div className="col-sm-6">
                        <p className="my-0">
                            {answer.survey_question.text}
                        </p>
                    </div>
                    <div className="col-sm-6 text-right">
                        {answer.answer}
                    </div>
                </div>
            </div>
        </div>
    );
}

function DetailQuestionWilling(props) {
    const { answer } = props;
    const value = parseInt(answer.answer, 10);
    
    return (
        <div className="card my-1">
            <div className="card-block">
                <div className="row">
                    <div className="col-sm-6">
                        <p className="my-0">
                            {answer.survey_question.text}
                        </p>
                    </div>
                    <div className="col-sm-6 text-right">
                        {willing[value]}
                    </div>
                </div>
            </div>
        </div>
    );
}

function DetailQuestionSatisfaction(props) {
    const { answer } = props;
    const value = parseInt(answer.answer, 10);
    
    return (
        <div className="card my-1">
            <div className="card-block">
                <div className="row">
                    <div className="col-sm-6">
                        <p className="my-0">
                            {answer.survey_question.text}
                        </p>
                    </div>
                    <div className="col-sm-6 text-right">
                        {satistaction[value]}
                    </div>
                </div>
            </div>
        </div>
    );
}

function DetailQuestion(props) {
    const {answer} = props;
    switch(answer.survey_question.kind) {
        case 'rating' :
            return DetailQuestionRating(props);
        case 'willing' :
            return DetailQuestionWilling(props);
        case 'satistaction' :
            return DetailQuestionSatisfaction(props);
        case 'textarea' :
            return DetailQuestionText(props);
        default :
            return null;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/reports/SurveyDetail.jsx
 **/